import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=556d845c&scoped=true&"
import script from "./Auth.vue?vue&type=script&lang=js&"
export * from "./Auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556d845c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('556d845c')) {
      api.createRecord('556d845c', component.options)
    } else {
      api.reload('556d845c', component.options)
    }
    module.hot.accept("./Auth.vue?vue&type=template&id=556d845c&scoped=true&", function () {
      api.rerender('556d845c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/layouts/Auth/Auth.vue"
export default component.exports